import { render } from "./incidents_cases.html?vue&type=template&id=6b52fdc2&external"
import script from "./incidents_cases.js?vue&type=script&lang=js&external"
export * from "./incidents_cases.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__